import SlideTimeline from './player-slide-timeline';
import { ITimelineParams } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-interface';

export default class IaSeqTimeline extends SlideTimeline {
    private clickSpid: string | null | undefined;
    public constructor({ animList, slideComponent, mediaManager, options, clickSpid, playManager }: ITimelineParams) {
        super({ animList, slideComponent, mediaManager, options, clickSpid, playManager });
        this.clickSpid = clickSpid;
    }
    /**
     * 触发器动画由原先的通过childTimeline控制动画的播放，调整为通过masterTimeline控制动画播放
     * 调整原因：通过childTimeline控制动画的播放，只会触发动画自身以及childTimeline上的事件，不会触发masterTimeline的事件，
     */
    public handleNextClick(order: number): void {
        this.killActiveAnimation();
        super.handleNextClick(order);
    }
}
